module.exports = __webpack_public_path__ + "images/skewness-06-faq-desktop.png";